import { useCallback, useEffect, useMemo, useState } from "react";
import "../global/basic.css"
import { API_URL } from "../shared/api";
import useBackupUser from "../shared/hooks/useBackupUser";
import RemainingJokersComponent from "./RemainingJokersComponent";
import GivenAnswersList from "./GivenAnswersList";
import MainComponent from "../global/mainlayout/MainComponent";
import Dialog from "../shared/components/Dialog";
import StartNewGameComponent from "../new-game/StartNewGameComponent";
import EditOrAddAnswerComponent from "./EditOrAddAnswerComponent";


export default function ActiveGamePage() {
  const user = useBackupUser();

  const [activeGame, setActiveGame] = useState(undefined);

  const [answer, setAnswer] = useState("");

  const [dialogOpen, setDialogOpen] = useState(false);
  const [editAnswerIndex, setEditAnswerIndex] = useState(-1);

  const fetchActiveGameAsync = useCallback(() => {
    fetch(`${API_URL}/users/${user?.id}/active-game`, {method: "GET"})
      .then(r => r.json())
      .then(setActiveGame)
      .catch(e => console.log("no active game."))
  }, [user?.id]);

  useEffect(() => {
    if(user)
      fetchActiveGameAsync();
  }, [user, user?.id, fetchActiveGameAsync])

  const handleStartNewGameConfirm = useCallback(() => {
    setDialogOpen(false);
    fetchActiveGameAsync();
  }, [fetchActiveGameAsync]);

  const nextQuestion = useMemo(() => 
    activeGame?.answers.indexOf("NOT_ANSWERED") ?? 0
  , [activeGame?.answers])

  const handleAnswerButtonClick = useCallback((answerValue) => {
    setAnswer("")
    if(editAnswerIndex === -1) {
      fetch(`${API_URL}/users/${user?.id}/active-game/answers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: `"${answerValue}"`
      })
        .then(r => r.json())
        .then(setActiveGame)
        .catch(e => console.log(e))
    } 
    else {
      fetch(`${API_URL}/users/${user?.id}/active-game/answers/${editAnswerIndex}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: `"${answerValue}"`
      })
        .then(r => r.json())
        .then(setActiveGame)
        .catch(e => console.log(e))
        .finally(() => setEditAnswerIndex(-1))
    }    
  }, [user?.id, editAnswerIndex])

  const toggleEditAnswerIndex = useCallback((v) => {
    if(editAnswerIndex === v)
      setEditAnswerIndex(-1);
    else
      setEditAnswerIndex(v);
  }, [editAnswerIndex])

  return (
    <MainComponent title={activeGame?.name ?? "Aktives Spiel"} onAction={() => setDialogOpen(true)} >
      <Dialog isOpen={dialogOpen} onCancel={() => setDialogOpen(false)} >
        <h2>Neues Spiel starten</h2>
        <StartNewGameComponent onStart={handleStartNewGameConfirm} />
      </Dialog>

      {activeGame && <>
      
        <div id="answer-next" className="section-container vertical-container gap-1 center">
          <EditOrAddAnswerComponent 
            nextQuestionIndex={nextQuestion} 
            editQuestionIndex={editAnswerIndex}
            disableJoker={activeGame.jokers === 0} 
            onClick={handleAnswerButtonClick} 
          />
          <RemainingJokersComponent value={activeGame.jokers} />
          <input className="top-margin decent-input secondary" type="text"  placeholder="Antwort eingeben..."
            value={answer} onChange={(e) => setAnswer(e.target.value)} />
        </div>

        <h3>Gegebene Antworten</h3>
        <GivenAnswersList answers={activeGame.answers} selectedIndex={editAnswerIndex} onClick={toggleEditAnswerIndex} />  
          
      </>}

      {!activeGame && <span className="center">Kein aktives Spiel.</span>}
    </MainComponent>
  );
}